export default "/react/settings-29c12dec.png";